import React, { Component } from 'react';
import {
  Alert,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input
} from 'reactstrap';
import InputMask from 'react-input-mask';

import {
  isCpfValid,
  isApartamentoValid,
  isFuncaoValid,
  isTelefoneValid
} from './../../utils/validation';

export default class extends Component {
  changeContratante(field) {
    return this.props.onChange('contratante', field);
  }

  changeContratado(field) {
    return this.props.onChange('contratado', field);
  }

  render() {
    let {
      disabled,
      contratante,
      contratado,
      onConfirm,
      errors,
      ...otherProps
    } = this.props;

    let contratanteIsValid = !contratante.id && !!contratante.text;
    let apartamentoIsValid =
      !contratanteIsValid || isApartamentoValid(contratante.apartamento);
    let nomeContratanteIsValid =
      !contratanteIsValid || 1 < contratante.nome.length;

    let contratanteIsAllValid =
      !contratanteIsValid || (apartamentoIsValid && nomeContratanteIsValid);

    let contratadoIsValid = !contratado.id;
    let cpfIsValid = isCpfValid(contratado.cpf);
    let identidadeIsValid = !contratado.rg || 2 < contratado.rg.length;
    let telefoneIsValid = isTelefoneValid(contratado.telefone);
    let funcaoIsValid = isFuncaoValid(contratado.funcao.nome);
    let matriculaIsValid =
      !contratado.matricula || 2 < contratado.matricula.length;
    let empresaIsValid =
      !contratado.empresa.nome || 2 < contratado.empresa.nome.length;
    let nomeContratadoIsValid = !!contratado.text && 1 < contratado.nome.length;

    let contratadoIsAllValid =
      !contratadoIsValid ||
      [
        nomeContratadoIsValid,
        cpfIsValid,
        funcaoIsValid,
        identidadeIsValid,
        telefoneIsValid,
        matriculaIsValid,
        empresaIsValid
      ].every(v => v);

    let everythingIsValid = contratanteIsAllValid && contratadoIsAllValid;

    return (
      <Modal {...otherProps} backdrop className="modal-inclusao-checkin">
        <form onSubmit={onConfirm}>
          <ModalBody>
            {contratanteIsValid && (
              <fieldset className="row group-contratante">
                <legend className="col-sm-12">Contratante</legend>
                <FormGroup className="col-sm-12">
                  <Label>Nome completo *</Label>
                  <Input
                    disabled={disabled}
                    value={contratante.nome}
                    maxLength={50}
                    valid={nomeContratanteIsValid}
                    onChange={this.changeContratante('nome')}
                  />
                </FormGroup>
                <FormGroup className="col-sm-12">
                  <Label>Apartamento *</Label>
                  <Input
                    autoFocus={true}
                    disabled={disabled}
                    maxLength={4}
                    tag={InputMask}
                    mask="9999"
                    maskChar={null}
                    valid={apartamentoIsValid}
                    value={contratante.apartamento}
                    onChange={this.changeContratante('apartamento')}
                  />
                </FormGroup>
              </fieldset>
            )}
            {contratadoIsValid && (
              <fieldset className="row group-contratado">
                <legend className="col-sm-12">Contratado</legend>
                <FormGroup className="col-sm-12 field-nome-contratado">
                  <Label>Nome completo *</Label>
                  <Input
                    disabled={disabled}
                    value={contratado.nome}
                    maxLength={50}
                    valid={nomeContratadoIsValid}
                    onChange={this.changeContratado('nome')}
                  />
                </FormGroup>
                <FormGroup className="col-sm-7 order-1 field-funcao-contratado">
                  <Label>Função *</Label>
                  <Input
                    autoFocus={!contratanteIsValid}
                    disabled={disabled}
                    maxLength={50}
                    value={contratado.funcao.nome}
                    valid={funcaoIsValid}
                    onChange={this.changeContratado(['funcao', 'nome'])}
                  />
                </FormGroup>
                <FormGroup className="col-sm-5 order-4 order-sm-2">
                  <Label>Telefone</Label>
                  <Input
                    disabled={disabled}
                    maxLength={16}
                    tag={InputMask}
                    mask={
                      11 === contratado.telefone.replace(/\D+/g, '').length
                        ? '(99) 999-999-999'
                        : '(99)  9999-99999'
                    }
                    maskChar={null}
                    value={contratado.telefone}
                    valid={telefoneIsValid}
                    onChange={this.changeContratado('telefone')}
                  />
                </FormGroup>
                <FormGroup className="col-sm-5 order-2 order-sm-3 field-cpf-contratado">
                  <Label>CPF *</Label>
                  <Input
                    disabled={disabled}
                    maxLength={14}
                    tag={InputMask}
                    mask="999.999.999-99"
                    maskChar={null}
                    valid={cpfIsValid}
                    value={contratado.cpf}
                    onChange={this.changeContratado('cpf')}
                  />
                </FormGroup>
                <FormGroup className="col-sm-7 order-3 order-sm-4 field-rg-contratado">
                  <Label>RG</Label>
                  <Input
                    disabled={disabled}
                    maxLength={20}
                    value={contratado.rg}
                    valid={identidadeIsValid}
                    onChange={this.changeContratado('rg')}
                  />
                </FormGroup>
                <FormGroup className="col-sm-8 order-5">
                  <Label>Empresa</Label>
                  <Input
                    disabled={disabled}
                    maxLength={50}
                    value={contratado.empresa.nome}
                    valid={empresaIsValid}
                    onChange={this.changeContratado(['empresa', 'nome'])}
                  />
                </FormGroup>
                <FormGroup className="col-sm-4 order-6">
                  <Label>Matrícula</Label>
                  <Input
                    disabled={disabled}
                    maxLength={20}
                    value={contratado.matricula}
                    valid={matriculaIsValid}
                    onChange={this.changeContratado('matricula')}
                  />
                </FormGroup>
              </fieldset>
            )}
            {errors.map((errorMessage, i) => (
              <Alert key={i} color="danger">
                {errorMessage}
              </Alert>
            ))}
          </ModalBody>
          <ModalFooter>
            {disabled && (
              <Button disabled={true} color="dark">
                Aguarde...
              </Button>
            )}
            {!disabled && (
              <Button
                className="action-checkin"
                type="submit"
                disabled={!everythingIsValid}
                color="success"
              >
                Confirma
              </Button>
            )}
          </ModalFooter>
        </form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/registroAcesso/InclusaoCheckin.js